import React from "react";
import { CompileMarkdown } from "../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler";
import { Props_SnippetImageAndTextButtons } from "./ImageAndTextButtons.props";

export const SnippetImageAndTextButtons = (
  props: Props_SnippetImageAndTextButtons
) => {
  const reversed = props.image?.position?.value === "left";

  return (
    <section className={`snippet-image-and-text-buttons ${reversed ? "snippet-image-and-text-buttons--reversed" : ""}`}>
      <div className="snippet-image-and-text-buttons__container">
        <div className="snippet-image-and-text-buttons__content-section">
          <div className="snippet-image-and-text-buttons__content">
            <h2 className="snippet-image-and-text-buttons__title"> {props.heading?.heading?.value} </h2>
            <div className="snippet-image-and-text-buttons__text"> {CompileMarkdown(props.markdown?.markdown?.value || "")} </div>
            <div className="snippet-image-and-text-buttons__buttons">
              {props.repeatable_link?.map((link, index) => (
                <a key={index} className="snippet-image-and-text-buttons__link" href={link.linkhref?.value}> {link.linktext?.value}</a>
              ))}
            </div>
          </div>
        </div>

        {props.image && (
          <div className="snippet-image-and-text-buttons__image-section">
            <figure className="snippet-image-and-text-buttons__image-container">
              <img
                className="snippet-image-and-text-buttons__image"
                src={props.image.src?.value}
                alt={props.image.alt?.value}
                height="735"
                width="560"
                loading="lazy"
              />
            </figure>
          </div>
        )}
      </div>
    </section>
  );
};
